import { Link } from "react-router-dom";
import { Instagram, MapPin, MessageCircle, Phone } from "lucide-react";
import { contact, navLinks, partner } from "../data/siteData";

export const SiteFooter = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#080C16] px-5 py-14 text-slate-300 md:px-10">
    <div className="mx-auto grid max-w-7xl gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
      <div>
        <p data-testid="footer-brand-name" className="font-heading text-2xl font-black uppercase tracking-tight text-white">Kannur Surf Club</p>
        <p data-testid="footer-brand-copy" className="mt-4 max-w-md text-sm leading-7 text-slate-400">
          Sunrise sessions, coastal stays, and water adventures shaped by Kerala’s northern shoreline.
        </p>
        <p data-testid="footer-partner-text" className="mt-5 max-w-md text-xs uppercase tracking-[0.22em] text-slate-500">
          In partnership with{" "}
          <a
            data-testid="footer-partner-link"
            href={partner.url}
            target="_blank"
            rel="noreferrer"
            className="text-[#FFC059] transition-colors duration-300 hover:text-white"
          >
            {partner.name}
          </a>
        </p>
      </div>
      <div>
        <p data-testid="footer-links-heading" className="text-xs font-bold uppercase tracking-[0.24em] text-[#FF5E3A]">Explore</p>
        <div className="mt-5 grid gap-3">
          {navLinks.map((link) => (
            <Link data-testid={`footer-link-${link.label.toLowerCase().replaceAll(" ", "-")}`} key={link.path} to={link.path} className="text-sm text-slate-400 transition-colors duration-300 hover:text-white">
              {link.label}
            </Link>
          ))}
        </div>
      </div>
      <div>
        <p data-testid="footer-contact-heading" className="text-xs font-bold uppercase tracking-[0.24em] text-[#FF5E3A]">Contact</p>
        <div className="mt-5 grid gap-3 text-sm text-slate-400">
          <div data-testid="footer-manager-actions" className="rounded-xl border border-white/10 p-3">
            <p className="mb-2 text-white">Club Manager: {contact.managerPhone}</p>
            <div className="flex flex-wrap gap-3">
              <a data-testid="footer-manager-phone-link" href={`tel:${contact.managerPhoneRaw}`} className="flex items-center gap-2 transition-colors duration-300 hover:text-white"><Phone className="h-4 w-4" />Call</a>
              <a data-testid="footer-manager-whatsapp-link" href={contact.managerWhatsapp} target="_blank" rel="noreferrer" className="flex items-center gap-2 transition-colors duration-300 hover:text-white"><MessageCircle className="h-4 w-4" />WhatsApp</a>
            </div>
          </div>
          <div data-testid="footer-owner-actions" className="rounded-xl border border-white/10 p-3">
            <p className="mb-2 text-white">Activity Operator: {contact.ownerPhone}</p>
            <div className="flex flex-wrap gap-3">
              <a data-testid="footer-owner-phone-link" href={`tel:${contact.ownerPhoneRaw}`} className="flex items-center gap-2 transition-colors duration-300 hover:text-white"><Phone className="h-4 w-4" />Call</a>
              <a data-testid="footer-owner-whatsapp-link" href={contact.ownerWhatsapp} target="_blank" rel="noreferrer" className="flex items-center gap-2 transition-colors duration-300 hover:text-white"><MessageCircle className="h-4 w-4" />WhatsApp</a>
            </div>
          </div>
          <span data-testid="footer-location-text" className="flex items-center gap-3"><MapPin className="h-4 w-4" />{contact.location}</span>
          <a data-testid="footer-instagram-link" href={contact.instagramUrl} target="_blank" rel="noreferrer" className="flex items-center gap-3 transition-colors duration-300 hover:text-white"><Instagram className="h-4 w-4" />{contact.instagramHandle}</a>
        </div>
      </div>
    </div>
  </footer>
);
